interface PageTitleProps {
  className?: string;
  title: string;
}

export const PageTitle = ({ className = "", title = "" }: PageTitleProps) => {
  return <h2 className={`text-xl font-semibold text-foreground dark:text-dark-text ${className}`}>{title}</h2>;
};
